export default __webpack_public_path__ + "static/media/R9.0cc09283.JPG";